import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import StructuredData, {
  getArticleSchema,
  getBreadcrumbSchema,
  getWebPageSchema,
} from '@/components/feature/StructuredData';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Article() {
  const { slug } = useParams<{ slug: string }>();
  const fallbackArticle = articles[0];
  const article = articles.find((a) => a.slug === slug) || fallbackArticle;
  const [commentText, setCommentText] = useState('');
  const [comments, setComments] = useState([
    { id: 1, user: '吃瓜群众甲', avatar: 'R', text: '这个瓜太大了！没想到还有这么多内幕，坐等后续发展。', time: '2小时前', likes: 128 },
    { id: 2, user: '八卦达人小王', avatar: '八', text: '作为圈内人补充一下，这事其实还有更劲爆的没爆出来...', time: '5小时前', likes: 256 },
    { id: 3, user: '理性吃瓜人', avatar: '理', text: '建议大家理性看待，等待官方回应，不要以讹传讹。', time: '8小时前', likes: 89 },
    { id: 4, user: '娱乐观察员', avatar: '观', text: '这种瓜在圈内其实很常见，只是这次被爆出来了而已。娱乐圈的水不是一般的深。', time: '12小时前', likes: 312 },
    { id: 5, user: '互联网老兵', avatar: '老', text: '这种事情的曝光往往只是一个开始，后续还会牵扯出更多的人和事。拭目以待。', time: '1天前', likes: 178 },
  ]);

  useEffect(() => {
    if (article) {
      document.title = `${article.title} - 黑料718`;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', article.excerpt);
      }
      window.scrollTo(0, 0);
    }
  }, [article]);

  const handleSubmitComment = (e: React.FormEvent) => {
    e.preventDefault();
    if (!commentText.trim()) return;
    const newComment = {
      id: comments.length + 1,
      user: '匿名用户',
      avatar: '匿',
      text: commentText.trim(),
      time: '刚刚',
      likes: 0,
    };
    setComments([newComment, ...comments]);
    setCommentText('');
  };

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 px-4">
          <div className="max-w-7xl mx-auto text-center py-20">
            <h1 className="text-2xl font-heading font-bold text-foreground-950">文章不存在</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.id !== article.id && (a.categorySlug === article.categorySlug))
    .slice(0, 4);

  if (relatedArticles.length < 4) {
    const moreArticles = articles
      .filter((a) => a.id !== article.id && a.categorySlug !== article.categorySlug)
      .slice(0, 4 - relatedArticles.length);
    relatedArticles.push(...moreArticles);
  }

  return (
    <>
      <StructuredData
        data={getArticleSchema({
          title: article.title,
          description: article.excerpt,
          url: `http://qinglianhb.cn/article/${article.slug}`,
          image: article.image,
          datePublished: article.publishDate,
          dateModified: article.publishDate,
          author: article.author,
        })}
      />
      <StructuredData
        data={getBreadcrumbSchema([
          { name: '首页', url: 'http://qinglianhb.cn/' },
          { name: article.category, url: `http://qinglianhb.cn/category/${article.categorySlug}` },
          { name: article.title, url: `http://qinglianhb.cn/article/${article.slug}` },
        ])}
      />
      <StructuredData
        data={getWebPageSchema(
          article.title,
          article.excerpt,
          `http://qinglianhb.cn/article/${article.slug}`
        )}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          <article className="px-4 md:px-6 py-6 md:py-10">
            <div className="max-w-4xl mx-auto">
              {/* Breadcrumb */}
              <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6 flex-wrap">
                <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  首页
                </Link>
                <i className="ri-arrow-right-s-line"></i>
                <Link
                  to={`/category/${article.categorySlug}`}
                  className="hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {article.category}
                </Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-foreground-600 line-clamp-1">{article.title}</span>
              </nav>

              {/* Article Header */}
              <header>
                <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
                  {article.category}
                </span>
                <h1 className="text-xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-snug">
                  {article.title}
                </h1>
                <div className="flex flex-wrap items-center gap-4 mt-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line"></i>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.readCount >= 10000
                      ? `${(article.readCount / 10000).toFixed(1)}万 阅读`
                      : `${article.readCount} 阅读`}
                  </span>
                </div>
                <div className="flex flex-wrap gap-2 mt-3">
                  {article.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2.5 py-1 bg-background-100 text-foreground-500 text-xs rounded-full whitespace-nowrap"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              </header>

              {/* Featured Image */}
              <div className="mt-6 rounded-xl overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full aspect-[16/9] object-cover object-top"
                />
              </div>

              {/* Article Content */}
              <div
                className="mt-8 prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed
                  [&_p]:mb-4 [&_p]:text-sm md:[&_p]:text-base [&_p]:leading-loose"
                dangerouslySetInnerHTML={{ __html: article.content }}
              />

              {/* Share & Actions */}
              <div className="flex items-center justify-between mt-10 pt-6 border-t border-background-200/70">
                <div className="flex items-center gap-3">
                  <button className="flex items-center gap-1.5 px-4 py-2 bg-background-100 text-foreground-600 text-sm rounded-full hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-thumb-up-line"></i>
                    点赞
                  </button>
                  <button className="flex items-center gap-1.5 px-4 py-2 bg-background-100 text-foreground-600 text-sm rounded-full hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-star-line"></i>
                    收藏
                  </button>
                  <button className="flex items-center gap-1.5 px-4 py-2 bg-background-100 text-foreground-600 text-sm rounded-full hover:bg-primary-50 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-share-forward-line"></i>
                    分享
                  </button>
                </div>
                <Link
                  to={`/category/${article.categorySlug}`}
                  className="text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium whitespace-nowrap"
                >
                  更多{article.category} &rarr;
                </Link>
              </div>
            </div>
          </article>

          {/* Comments Section */}
          <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-8">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
                  网友热议
                </span>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  评论区
                </h2>
                <p className="text-xs text-foreground-500 mt-1">{comments.length} 条评论</p>
              </div>

              {/* Comment Form */}
              <form onSubmit={handleSubmitComment} className="mb-8">
                <div className="flex gap-3">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center font-bold text-sm">
                    匿
                  </div>
                  <div className="flex-1">
                    <textarea
                      value={commentText}
                      onChange={(e) => setCommentText(e.target.value)}
                      placeholder="发表你的看法..."
                      className="w-full px-4 py-3 bg-background-50 border border-background-200/70 rounded-lg text-sm text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-300 resize-none"
                      rows={3}
                      maxLength={500}
                    />
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-xs text-foreground-400">{commentText.length}/500</span>
                      <button
                        type="submit"
                        disabled={!commentText.trim()}
                        className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer whitespace-nowrap"
                      >
                        发表评论
                      </button>
                    </div>
                  </div>
                </div>
              </form>

              {/* Comments List */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {comments.map((comment) => (
                  <div
                    key={comment.id}
                    className="bg-background-50 rounded-lg border border-background-200/70 p-4"
                  >
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 flex-shrink-0 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center font-bold text-xs">
                        {comment.avatar}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between">
                          <span className="text-sm font-medium text-foreground-900">{comment.user}</span>
                          <span className="text-xs text-foreground-400">{comment.time}</span>
                        </div>
                        <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
                        <div className="flex items-center gap-3 mt-2">
                          <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                            <i className="ri-thumb-up-line"></i>
                            {comment.likes}
                          </button>
                          <button className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                            回复
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Related Articles */}
          <section className="py-10 md:py-14 px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-6 md:mb-8">
                相关爆料
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {relatedArticles.map((ra) => (
                  <ArticleCard key={ra.id} {...ra} />
                ))}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
            <div className="max-w-4xl mx-auto">
              <div className="rounded-2xl overflow-hidden mb-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20with%20notification%20alerts%20on%20screen%20placed%20on%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20cozy%20evening%20atmosphere%2C%20lifestyle%20photography%2C%20digital%20news%20concept&width=1200&height=500&seq=cta-article-banner&orientation=landscape"
                  alt="爆料投稿"
                  className="w-full h-48 md:h-64 object-cover object-top"
                />
              </div>
              <div className="text-center">
                <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
                  你有<span className="italic text-primary-500 font-normal">料</span>要爆吗？
                </h2>
                <p className="mt-3 text-sm text-foreground-600 max-w-md mx-auto">
                  下载黑料718 APP，即可<strong>匿名投稿</strong>。我们保护每一位爆料人的隐私安全。
                </p>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 mt-6 px-8 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                  立即投稿
                </Link>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}